module.exports = __webpack_public_path__ + "static/consumed-dbc4934d86be1f1428fc3acd24a903a0.jpg";